var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.36 4.54667L9.51999 1.86C8.47333 1.12667 6.86666 1.16667 5.85999 1.94667L2.51999 4.55333C1.85333 5.07333 1.32666 6.14 1.32666 6.98V11.58C1.32666 13.28 2.70666 14.6667 4.40666 14.6667H11.5933C13.2933 14.6667 14.6733 13.2867 14.6733 11.5867V7.06667C14.6733 6.16667 14.0933 5.06 13.36 4.54667ZM8.49999 12C8.49999 12.2733 8.27333 12.5 7.99999 12.5C7.72666 12.5 7.49999 12.2733 7.49999 12V10C7.49999 9.72667 7.72666 9.5 7.99999 9.5C8.27333 9.5 8.49999 9.72667 8.49999 10V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.07c528b9a95ab04d44efc42a28ac3693.svg";
export { ForwardRef as ReactComponent };